import { Button, List, Stack, Text } from "basis";
import { usePageTracking } from "react-event-tracker";
import { Layout } from "../../Layout/Layout";

export const AccountType = ({ setScreen }) => {
  usePageTracking({
    page: {
      pageType: "input-page",
      siteSection: "accounts",
      siteSubSection: "",
      pageTitle: "link-existing-account-home",
    },
    user: {
      authenticationStatus: "logged in",
    },
  });

  return (
    <Layout>
      <Layout.Header>Link an existing account</Layout.Header>
      <Layout.Main>
        <Stack gap="6">
          <Text>
            Do you have an existing Latitude product?
            <br />
            Link your credit card or personal loan here to get a single view of
            all your accounts.
          </Text>
          <Text>
            You will need to supply the following information to link your
            account:
          </Text>
          <List>
            <List.Item>Date of birth</List.Item>
            <List.Item>Card or Personal loan account number</List.Item>
            <List.Item>Have your mobile phone handy</List.Item>
          </List>
          <Text>
            <strong>What type of account do you want to link?</strong>
          </Text>
          <Stack gap="6" direction-xs="horizontal">
            <Button variant="secondary" onClick={() => setScreen("CreditCard")}>
              Credit Card
            </Button>
            <Button
              variant="secondary"
              onClick={() => setScreen("PersonalLoan")}
            >
              Personal Loan
            </Button>
          </Stack>
        </Stack>
      </Layout.Main>
    </Layout>
  );
};
